import { fetchMyFundraisers } from '@client/connectivity/api.fundraiser';
import { selectAccessToken } from '@client/redux/user/userReducer';
import { putUser } from '@client/connectivity/api.user';
import {
  RESET_USER_REDUCER,
  SET_ACCESS_TOKEN,
  SET_USER_INFO,
  SET_AUTH_0_AUTHENTICATION,
  SET_USER_REDUCER,
  LOAD_MY_FUNDRAISERS,
  PUT_AND_HANDLE_USER,
} from './userReducer';

export function setAccessToken(accessToken) {
  return {
    type: SET_ACCESS_TOKEN,
    payload: accessToken,
  };
}

export function setUserInfo(cookies) {
  return {
    type: SET_USER_INFO,
    payload: cookies,
  };
}

export function setUserReducer(userReducer) {
  return {
    type: SET_USER_REDUCER,
    payload: userReducer,
  };
}

export function setAuth0Authentication(isAuthenticatedCookie) {
  return {
    type: SET_AUTH_0_AUTHENTICATION,
    payload: isAuthenticatedCookie,
  };
}

export function handleLogout(cookies) {
  return function(dispatch) {
    cookies.remove('userReducer');
    dispatch(resetUserReducer());
  };
}

export function resetUserReducer() {
  return {
    type: RESET_USER_REDUCER,
  };
}

export function putAndHandleUser(userInfo, userId) {
  return function(dispatch, getState) {
    const accessToken = selectAccessToken(getState());
    return putUser(userInfo, userId, accessToken).then((response) => {
      return dispatch({
        type: PUT_AND_HANDLE_USER,
        payload: response.data,
      });
    });
  };
}

export function loadMyFundraisers() {
  return function(dispatch, getState) {
    const accessToken = selectAccessToken(getState());

    return fetchMyFundraisers(accessToken).then((response) => {
      return dispatch({
        type: LOAD_MY_FUNDRAISERS,
        payload: response.data,
      });
    });
  };
}
